import React from "react";
import {
  Typography,
  Checkbox,
  FormControl,
  FormGroup,
  FormControlLabel,
  Button,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CardMedia,
  Slider,
  Stack,
  IconButton,
  Drawer,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { mediaUrl } from "../../../utils/cfImage";

export default function Filters(props) {
  const { component, filterDrawer, setFilterDrawer } = props;
  const devHelper = component.getHelpers("dev");
  const filters = component.getData("default.filters", []);
  const filesUrl = component.getHelpers("env").get("files_url");
  const imgVersion = component.getHelpers("value").getValue("images-version");

  return (
    <Drawer
      anchor="left"
      open={filterDrawer}
      onClose={() => setFilterDrawer(false)}
      ModalProps={{ keepMounted: true }}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: 360 },
          maxWidth: "100%",
          borderRadius: 0,
          boxShadow: "none",
          borderRight: "1px solid rgba(0,0,0,0.12)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 2,
            borderBottom: "1px solid rgba(0,0,0,0.12)",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Spartan-Bold",
              fontSize: 14,
              letterSpacing: "0.04em",
              textTransform: "uppercase",
            }}
          >
            Filters
          </Typography>
          <IconButton
            onClick={() => setFilterDrawer(false)}
            aria-label="Close filters"
            sx={{ color: "#000", p: 0.5 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>

        <Box sx={{ flex: 1, overflowY: "auto", px: 2, py: 1 }}>
          {filters.map((filter) => {
            const { type } = filter;
            const name = type === "price_range" ? "price" : type;

            return (
              <Accordion
                disableGutters
                elevation={0}
                sx={{
                  backgroundColor: "transparent",
                  border: "unset",
                  boxShadow: "unset",
                  "&::before": { opacity: "1!important" },
                }}
                key={`filter-${type}`}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`filter-${type}-content`}
                  id={`filter-${type}-header`}
                >
                  <Typography
                    sx={{
                      fontFamily: "Spartan-SemiBold",
                      fontSize: 13,
                      textTransform: "uppercase",
                      letterSpacing: "0.03em",
                    }}
                  >
                    {component.ucfirst(name)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    "&.MuiAccordionDetails-root": {
                      padding: "0px 8px 12px",
                    },
                  }}
                >
                  {type !== "price" ? (
                    <FormControl component="fieldset" sx={{ ml: 0 }}>
                      <FormGroup>
                        {component
                          .getData(`default.${type}s`, [])
                          .map((item, i) => {
                            const filterAmount = component.getFilterAmount(
                              type,
                              item,
                            );

                            return (
                              filterAmount > 0 && (
                                <FormControlLabel
                                  key={devHelper.getObjectValue(
                                    item,
                                    "_values.slug",
                                  )}
                                  disabled={
                                    devHelper.getObjectValue(
                                      item,
                                      "_values.total",
                                    ) === 0
                                  }
                                  id={
                                    devHelper.getObjectValue(
                                      item,
                                      "_values.slug",
                                    ) +
                                    "-" +
                                    i
                                  }
                                  control={
                                    <Checkbox
                                      onChange={() =>
                                        component.toggleFilter(type, item)
                                      }
                                      className="checkbox"
                                      checked={component.isFilterSelected(
                                        type,
                                        item,
                                      )}
                                    />
                                  }
                                  sx={{
                                    fontSize: "15px",
                                    "& .MuiTypography-root": {
                                      display: "contents!important",
                                    },
                                  }}
                                  label={
                                    type === "gem" || type === "color" ? (
                                      <>
                                        <CardMedia
                                          component="img"
                                          image={mediaUrl(
                                            filesUrl,
                                            `gems/${devHelper.getObjectValue(
                                              item,
                                              "_values.slug",
                                            )}.png`,
                                            { width: 100, version: imgVersion },
                                          )}
                                          title={devHelper.getObjectValue(
                                            item,
                                            "_values.name",
                                          )}
                                          onError={(e) => {
                                            e.target.src = mediaUrl(
                                              filesUrl,
                                              "assets/gem-not-found.png",
                                              { width: 100, version: imgVersion },
                                            );
                                          }}
                                          sx={{
                                            cursor: "pointer",
                                            maxWidth: "42px",
                                            borderRadius: 50,
                                            padding: "10px",
                                            maxHeight: "42px",
                                            display: "inline",
                                          }}
                                        />
                                        <Box
                                          component="span"
                                          sx={{ textTransform: "uppercase" }}
                                        >
                                          {devHelper.getObjectValue(
                                            item,
                                            "_values.name",
                                          ) +
                                            " (" +
                                            filterAmount +
                                            ")"}
                                        </Box>
                                      </>
                                    ) : (
                                      <Box
                                        component="span"
                                        sx={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {devHelper.getObjectValue(
                                          item,
                                          "_values.name",
                                        ) +
                                          " (" +
                                          filterAmount +
                                          ")"}
                                      </Box>
                                    )
                                  }
                                />
                              )
                            );
                          })}
                      </FormGroup>
                    </FormControl>
                  ) : (
                    <Slider
                      value={component.getPriceRange(filter)}
                      size="small"
                      sx={{ margin: "25px 5% 0px", maxWidth: "90%" }}
                      onChangeCommitted={(e, value) =>
                        component.changePriceRange(value, true)
                      }
                      onChange={(e, value) => component.changePriceRange(value)}
                      valueLabelDisplay="on"
                      aria-labelledby="range-slider"
                      min={component.getMinPrice(filter)}
                      max={component.getMaxPrice(filter)}
                    />
                  )}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Box>

        <Stack
          direction="row"
          spacing={1.5}
          sx={{
            px: 2,
            py: 2,
            borderTop: "1px solid rgba(0,0,0,0.12)",
            justifyContent: "space-between",
          }}
        >
          <Button
            sx={{
              bgcolor: "#fff",
              border: "1px solid #000",
              borderRadius: 0,
              color: "#000",
              px: 2,
              flex: 1,
              fontFamily: "Spartan-SemiBold",
              fontSize: 12,
              "&:hover": { bgcolor: "#fff" },
            }}
            onClick={() => {
              setFilterDrawer(false);
              component.clearFiltersAndFetch();
            }}
            id="clear_filters"
            size="small"
          >
            {component.ucfirst("clear Filters")}
          </Button>
          <Button
            sx={{
              bgcolor: "#000",
              border: "1px solid #000",
              borderRadius: 0,
              color: "#fff",
              px: 2,
              flex: 1,
              fontFamily: "Spartan-SemiBold",
              fontSize: 12,
              "&:hover": { bgcolor: "#000" },
            }}
            onClick={() => setFilterDrawer(false)}
            size="small"
          >
            {component.ucfirst("Show Results")}
          </Button>
        </Stack>
      </Box>
    </Drawer>
  );
}
